// "PARSING NOW" IS ONLY TRUE WHEN A JOB EXISTS. A file mint is best-effort by design the PUT URL
// always comes back, and when the parse dispatch failed the 201 carries `meta.
import type { SignedUpload } from "../types/contract";

/* * true when the server filed a parse job for the upload; false when it explicitly did not (`null`) */
export function uploadQueued(mint: Pick<SignedUpload, "job_id">): boolean {
  // `undefined` = an older service that never carried the id — no evidence either way, so keep the
  // historical optimism; `null` = the server SAID nobody will parse it
  return mint.job_id !== null;
}

/* * the note to show after a zone-file upload — honest about whether a parse will follow */
export function zoneUploadNote(
  mint: Pick<SignedUpload, "job_id">,
  filename: string,
): { text: string; err: boolean } {
  return uploadQueued(mint)
    ? {
        text: `Zones “${filename}” uploaded — parsing now; they’ll appear under Target Sampling Layers as “Imported - …”.`,
        err: false,
      }
    : {
        text: `Zones “${filename}” were stored but NOT queued for parsing — the server could not file the parse job. Nothing will appear from this upload; try again in a minute, and if it repeats tell support (the file is kept).`,
        err: true,
      };
}
